import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
} from "@nebular/theme";
import { UserService } from "../../../@core/services/user.service";

import { DialogProfileComponent } from "../../dialog-profile/dialog-profile.component";

import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";
import ReportSpam from "../../../models/report-spam.model";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { filter } from "rxjs/operators";
import Enrollment from "../../../models/enrollment.model";
import { StudentService } from "../../../services/student.service";

@Component({
  selector: "ngx-view-student",
  styleUrls: ["./view-student.component.scss"],
  templateUrl: "./view-student.component.html",
})
export class ViewStudentComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() student: Enrollment;
  @Input() mode?: string = "home"; //home / tutor / detail
  @Input() isMore? = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  view = "question";
  uid = "";
  menuItems: NbMenuItem[] = [
    { title: "Chi tiết", icon: "external-link-outline" },
  ];
  isMobile = false;

  constructor(
    public userService: UserService,
    private studentService: StudentService,
    private dialogService: NbDialogService,
    private router: Router,
    private nbMenuService: NbMenuService,
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
      });

    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  ngOnInit() {
    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === `action-buttons-${this.student.id}`),
        map(({ item }) => item),
        takeUntil(this.destroy$)
      )
      .subscribe((item) => {
        switch (item.title) {
          case "Sửa":
            this.edit(item.data);
            break;
          case "Xóa":
            this.delete(item.data.id);
            break;
          case "Chi tiết":
            break;
          default:
            break;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  reply() {
    this.view = "replies";
  }

  closeReply() {
    this.view = "main";
  }

  overview(item) {
    //open dialog view overview result
  }

  loadButtonAction(item) {
    if (item.createdBy === this.uid) {
      this.menuItems = [
        { title: "Sửa", icon: "edit-2-outline", data: item },
        { title: "Xóa", icon: "trash-2-outline", data: { id: item.id } },
        {
          title: "Chi tiết",
          icon: "external-link-outline",
          link: `/student/${this.student.id}`,
        },
      ];
    } else {
      this.menuItems = [
        {
          title: "Chi tiết",
          icon: "external-link-outline",
          link: `/student/${this.student.id}`,
        },
      ];
    }
  }

  report(item: ReportSpam) {
    this.onDelete.emit(item.refId);
  }

  navigateRef(item) {
    if (item.courseId != "") {
      this.router.navigateByUrl(`/course/${item.courseId}`);
    } else if (item.quizId != "") {
      this.router.navigateByUrl(`/quiz/${item.quizId}`);
    }
  }

  tagSelected(tag) {
    console.log("tagSelected:", tag);
  }

  delete(id) {
    if (!this.submitted) {
      this.submitted = true;
      this.dialogService
        .open(DialogYesNoPromptComponent, {
          context: {
            title: "Bạn có chắc khóa tài khoản này?",
          },
        })
        .onClose.subscribe((value) => {
          if (value) {
            this.loading = true;
            this.studentService
              .delete(id)
              .then((result) => {
                this.loading = false;
                this.submitted = false;
                this.onDelete.emit(id);
              })
              .catch((err) => {
                this.loading = false;
                this.submitted = false;
              });
          }
          this.submitted = false;
        });
    }
  }

  edit(item: Enrollment) {
    let lecBk = new Enrollment();
    lecBk = clone(item);
    // this.dialogService
    //   .open(DialogAnnouncementComponent, {
    //     context: {
    //       header: "Cập nhật bài viết",
    //       mode: "edit",
    //       student: lecBk,
    //     },
    //     closeOnBackdropClick: false,
    //   })
    //   .onClose.subscribe((value) => {
    //     if (value) {
    //       item = value;
    //       this.student = value;
    //       this.onEdit.emit(value);
    //     }
    //   });
  }
}
